import { debouncer, documentReady } from "../Utility/utils";

documentReady((event) => {
  // Play videos on play button
  document.addEventListener('click', function(e) {
    if (e.target.matches('a.video_play') || !!e.target.closest('a.video_play')) {
      e.preventDefault();

      const target = e.target.closest('.video_block');
      const trigger = target.querySelector('.video_poster');

      // Fade out trigger
      trigger.classList.add('fadeOut');
      setTimeout(function(){
        trigger.classList.add('hide');
      }, 300);

      // if the video is an iframe
      if(!!target.querySelector('iframe')){
        const iframe = target.querySelector('iframe');
        let src = iframe.getAttribute('src');
        if(iframe.getAttribute('data-src')){
          src = iframe.getAttribute('data-src');
        }
        const playSrc = src + '&autoplay=true';
        iframe.setAttribute('src', playSrc);
      } else {
        const video = target.querySelector('video');
        video.play();
      }
    }
  });
});
